import React from "react";
import { Clock, Heart, Moon } from "lucide-react";
import PainLandingPage from "@/pages/PainLandingPage";

const NewParentsPage = () => (
  <PainLandingPage
    ns="newParents"
    variant="soft"
    photo="/assets/lifestyle/couple-interlude.jpg"
    icons={[<Clock size={20} />, <Heart size={20} />, <Moon size={20} />]}
  />
);

export default NewParentsPage;
